// Keep support settings separate from the main API. Only explicit ticket submissions send the website login token.
export const CHATBOT_CONFIG = {
  // Support is paused. Set this to true when the chatbot should be available again.
  enabled: false,
  // Production must point to the separately hosted support API (HTTPS origin, without /api/support).
  apiBaseUrl: process.env.REACT_APP_CHATBOT_API_URL?.trim().replace(/\/+$/, '') ||
    (process.env.NODE_ENV === 'development' ? 'http://localhost:5080' : ''),
  // Embedded pages have little room; opt in explicitly if the parent site needs the widget.
  showWhenEmbedded: false,
};

